import {Component, effect, inject, input, InputSignal, model, ModelSignal} from '@angular/core';
import {TableControlComponent} from '../../../components/control/table-control/table-control.component';
import {TableControlModule} from '../../../components/control/table-control/table-control.module';
import {
  CSV_EXPORT_ACTION,
  CSV_IMPORT_ACTION,
  DELETE_ACTION,
  DUPLICATE_ACTION,
  NEW_ENTRY_ACTION,
} from '../../../components/control/table-control/default-table-actions.constant';
import {IFilter} from '../../../../../../nucleus/src/lib/control/interfaces/filter.interface'
import {ITableAction} from '../../../components/control/table-control/interfaces/actions.interface';
import {ToolbarStore} from '../../../components/home-without-gl/toolbar/toolbar.store';

@Component({
  selector: 'lib-guid-table-control',
  templateUrl: '../../../components/control/table-control/table-control.component.html',
  styleUrl: '../../../components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
})
export class GuidTableControlComponent extends TableControlComponent {
  private _toolbarStore: ToolbarStore = inject(ToolbarStore);

  override GUID: string;
  inputGUID: InputSignal<string> = input.required<string>();
  override actions: ModelSignal<ITableAction[]>  = model<ITableAction[]>([
    NEW_ENTRY_ACTION,
    DELETE_ACTION,
    CSV_EXPORT_ACTION,
    CSV_IMPORT_ACTION,
    DUPLICATE_ACTION,
  ]);

  constructor() {
    effect((): void => {
      this.GUID = this.inputGUID();
    });

    effect((): void => {
      const toolbarFilterDto: IFilter = this._toolbarStore.toolbarFilterDto();
      if (toolbarFilterDto) {
        this.patchFilter({...toolbarFilterDto});
      }
    }, {allowSignalWrites: true});
    super();
  }
}
